const Report = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-package-type" */ '@/pages/base-info/order-properties/package-type/index.vue'
  )
const Create = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-package-type" */ '@/pages/base-info/order-properties/package-type/create.vue'
  )
const Edit = () =>
  import(
    /* webpackChunkName: "base-info-order-properties-package-type" */ '@/pages/base-info/order-properties/package-type/edit.vue'
  )

export default {
  path: 'package-type',
  meta: {
    label: 'packageTypes',
    auth: 'packageType'
  },
  component: {
    name: 'PackageType',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'BaseInfoOrderPropertiesPackageType',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: Report
    },
    {
      name: 'BaseInfoCreateOrderPropertiesPackageType',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: Create
    },
    {
      name: 'BaseInfoEditOrderPropertiesPackageType',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: Edit,
      props: true
    }
  ]
}
